import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/pages/Index.vue";
import Redirect from "@/components/Redirect.vue";
import IndexPage from "@/components/pages/IndexPage.vue";
import LoadingAuth from "@/components/pages/LoadingAuth.vue";
import SmsOptIn from "@/components/SmsOptIn.vue";
import SmsOptOut from "@/components/SmsOptOut.vue";
import EmailUnsubscribe from "@/components/EmailUnsubscribe.vue";
import TermsAndPrivacyPolicy from "@/components/pages/TermsAndPrivacyPolicy.vue";
import WhatsNew from "@/components/pages/WhatsNew.vue";
import LPMarketingAfiliados from "@/components/pages/LPMarketingAfiliados.vue"
import TestePage from "@/components/pages/TestePage.vue"
import authSession from "@/service/auth-session";
import { getSubdomainCode } from "@/service/subdomain";

Vue.use(Router);

const isLogged = (to, from, next) => {
  Vue.nextTick(() => {
    if(to.meta.title)
      document.title = to.meta.title;
  });
  authSession.checkSession().then(authenticated => {
    if(!authenticated)
      next("/");
    else
      next()
  });
};

const router = new Router({
  routes: [
    {
      path: '/teste',
      name: 'teste',
      component: TestePage,
      meta: {
        title: 'migly - teste',
      },
    },
    {
      path: '/lp',
      name: 'migly',
      component: LPMarketingAfiliados,
      meta: {
        title: 'migly - lp',
      },
    }, 
    {
      path: "/",
      name: 'Home',
      component: TestePage,
      meta: {
        title: 'migly',
      },
    },
    {
      path: "/conversion",
      name: 'Conversion',
      component: TestePage,
      meta: {
        title: 'migly',
      },
    },
    {
      path: "/privacy-policy",
      name: 'TermsAndPrivacyPolicy',
      component: TermsAndPrivacyPolicy,
      meta: {
        title: 'migly terms and privacy policy',
      },
    },
    {
      path: "/whats-new",
      name: 'WhatsNew',
      component: WhatsNew,
      meta: {
        title: 'Novidades',
      },
    },
    {
      path: "/g",
      name: 'Google',
      component: TestePage,
      meta: {
        title: 'migly',
      },
    },
    {
      path: "/f",
      name: 'Facebook',
      component: TestePage,
      meta: {
        title: 'migly',
      },
    },
    {
      path: "/gerador-de-utm",
      name: 'PillarGeradorDeUtm',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/PillarGeradorDeUtm.vue"),
      meta: {
        title: 'migly - gerador de utm',
      },
    },
    {
      path: "/encurtador-de-link-para-afiliados",
      name: 'PillarEncurtadorAfiliados',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/PillarEncurtadorAfiliados.vue"),
      meta: {
        title: 'migly - encurtador de link para afiliados',
      },
    },
    {
      path: "/pagina-de-vendas-para-afiliados",
      name: 'PillarPaginaDeVendasParaAfiliados',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/PillarPaginaDeVendasParaAfiliados.vue"),
      meta: {
        title: 'migly - página de vendas para afiliados',
      },
    },
    {
      path: "/blog/o-que-e-utm",
      name: 'ArticleOQueEUtm',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleOQueEUtm.vue"),
      meta: {
        title: 'migly - o que é utm',
      },
    },
    {
      path: "/blog/o-que-e-utm-source",
      name: 'ArticleOQueEUtmSource',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleOQueEUtmSource.vue"),
      meta: {
        title: 'migly - o que é utm source',
      },
    },
    {
      path: "/blog/o-que-e-utm-medium",
      name: 'ArticleOQueEUtmMedium',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleOQueEUtmMedium.vue"),
      meta: {
        title: 'migly - o que é utm medium',
      },
    },
    {
      path: "/blog/o-que-e-utm-campaign",
      name: 'ArticleOQueEUtmCampaign',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleOQueEUtmCampaign.vue"),
      meta: {
        title: 'migly - o que é utm campaign',
      },
    },
    {
      path: "/blog/o-que-e-utm-content",
      name: 'ArticleOQueEUtmContent',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleOQueEUtmContent.vue"),
      meta: {
        title: 'migly - o que é utm content',
      },
    },
    {
      path: "/blog/como-criar-utm",
      name: 'ArticleComoCriarUtm',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleComoCriarUtm.vue"),
      meta: {
        title: 'migly - como criar utm',
      },
    },
    {
      path: "/blog/como-rastrear-cliques-em-links",
      name: 'ArticleComoRastrearCliques',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleComoRastrearCliques.vue"),
      meta: {
        title: 'migly - como rastrear cliques em links',
      },
    },
    {
      path: "/blog",
      name: 'BlogHome',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/BlogHome.vue"),
      meta: {
        title: 'migly - blog',
      },
    },
    {
      path: "/blog/open-graph-personalizacao-de-links",
      name: 'ArticleOpenGraphPersonalizacao',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleOpenGraphPersonalizacao.vue"),
      meta: {
        title: 'migly - open graph e personalização de links',
      },
    },
    {
      path: "/blog/como-gerar-leads-com-ebook",
      name: 'ArticleComoGerarLeadsComEbook',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleComoGerarLeadsComEbook.vue"),
      meta: {
        title: 'migly - como gerar leads com um e-book',
      },
    },
    {
      path: "/blog/renda-extra-com-migly-pro",
      name: 'ArticleRendaExtraComMiglyPro',
      component: () => import(/* webpackChunkName: "seo-content" */ "@/components/pages/seo/ArticleRendaExtraComMiglyPro.vue"),
      meta: {
        title: 'migly - renda extra com o migly pro',
      },
    },
    {
      path: "/loading",
      name: 'Loading Auth',
      component: LoadingAuth,
      meta: {
        title: 'login',
      },
    },
    {
      path: "/painel",
      component: () => import(/* webpackChunkName: "painel" */ "./components/pages/painel/Painel.vue"),
      beforeEnter: isLogged,
      children: [
        {
          path: "links",
          name: 'Painel links',
          component: () => import(/* webpackChunkName: "painel" */ "./components/pages/painel/PainelLinks"),
          beforeEnter: isLogged,
          meta: {
            title: 'painel - encurtador de urls',
          },
          children: [
            {
              path: "shortened",
              name: 'Painel address',
              component: () => import(/* webpackChunkName: "painel" */ "@/components/pages/painel/PainelURLShortener.vue"),
              beforeEnter: isLogged,
              meta: {
                title: 'painel - encurtador de urls',
              },
              children: [
    
              ]
            },
            {
              path: "page-bio",
              name: 'Painel page bio',
              component: () => import(/* webpackChunkName: "painel" */ "./components/pages/painel/PainelBioPage"),
              beforeEnter: isLogged,
              meta: {
                title: 'painel - biografia',
              },
              children: [
    
              ]
            },
            {
              path: "shortened/:id",
              name: 'Painel Address',
              component: () => import(/* webpackChunkName: "painel" */ "@/components/pages/painel/PainelURLShortener.vue"),
              beforeEnter: isLogged,
              meta: {
                title: 'painel - encurtador de urls',
              },
              children: [

              ]
            },
          ]
        },
        {
          path: 'whats-new',
          name: 'WhatsNew',
          component: WhatsNew,
          meta: {
            title: 'Novidades',
          },
        },
        {
          path: "plans",
          name: 'Painel Plans',
          component: () => import('./components/pages/painel/PainelPlans.vue'),
          beforeEnter: isLogged,
          meta: {
            title: 'painel - planos',
          },
        },
        {
          path: "api-reference",
          name: 'Painel API Reference',
          component: () => import(/* webpackChunkName: "painel" */ "./components/pages/painel/PainelApiReferencePage"),
          beforeEnter: isLogged,
          meta: {
            title: 'painel - API Reference',
          },
          children: [

          ]
        },
        {
          path: "sms",
          name: 'Painel SMS',
          component: () => import(/* webpackChunkName: "painel" */ "./components/pages/painel/PainelSMSPage"),
          beforeEnter: isLogged,
          meta: {
            title: 'painel - sms',
          },
          children: [
            {
              path: "",
              name: 'Page SMS',
              component: () => import(/* webpackChunkName: "painel" */ "@/components/pages/SMSPage.vue"),
              beforeEnter: isLogged,
              meta: {
                title: 'painel - sms',
              },
              children: [
    
              ]
            },
            {
              path: "sender",
              name: 'Page SMS',
              component: () => import(/* webpackChunkName: "painel" */ "@/components/pages/SMSPage.vue"),
              beforeEnter: isLogged,
              meta: {
                title: 'painel - sms',
              },
              children: [
    
              ]
            },
            {
              path: "contacts",
              name: 'Page Contacts',
              component: () => import(/* webpackChunkName: "painel" */ "@/components/pages/ContactsPage.vue"),
              beforeEnter: isLogged,
              meta: {
                title: 'painel - contacts',
              },
              children: [
    
              ]
            },
          ]
        },
        {
          path: "nfoproduct",
          redirect: "/painel/infoproduct",
        },
        {
          path: "infoproduct",
          name: 'Painel Infoproduto',
          component: () => import(/* webpackChunkName: "painel" */ "./components/pages/painel/PainelInfoProduct"),
          beforeEnter: isLogged,
          meta: {
            title: 'painel - página de vendas',
          },
          children: [
            {
              path: "",
              name: 'Page Infoproduto',
              component: () => import(/* webpackChunkName: "painel" */ "@/components/pages/InfoProdutoPage.vue"),
              beforeEnter: isLogged,
              meta: {
                title: 'painel - página de vendas',
              },
              children: [

              ]
            },
          ]
        },
      ]
    },
    {
      title: 'migly - sms opt-in',
      path: "/i/:code",
      name: 'SmsOptIn',
      component: SmsOptIn,
      children: [
      ]
    },
    {
      title: 'migly - sms opt-out',
      path: "/o/:code",
      name: 'SmsOptOut',
      component: SmsOptOut,
      children: [
      ]
    },
    {
      title: 'migly - cancelar inscrição',
      path: "/email/unsubscribe/:token",
      name: 'EmailUnsubscribe',
      component: EmailUnsubscribe,
      children: [
      ]
    },
    {
      title: 'migly - redirecionamento',
      path: "/:code",
      name: 'Redirect',
      component: Redirect,
      children: [
        {
          path: '',
          name: 'Index',
          component: Index,
          meta: {
            title: 'migly',
          },
          children: [
            {
              path: '',
              name: 'Index',
              component: IndexPage,
              meta: {
                title: 'migly',
              },
            }, 
          ]
        },
      ]
    },
    {
      title: 'migly - redirecionamento',
      path: "/:code/:contactCode",
      name: 'Redirect',
      component: Redirect,
      children: [
        {
          path: '',
          name: 'Index',
          component: Index,
          meta: {
            title: 'migly',
          },
          children: [
            {
              path: '',
              name: 'Index',
              component: IndexPage,
              meta: {
                title: 'migly',
              },
            }, 
          ]
        },
      ]
    },
  ],
  base: __dirname,
  mode: "history",
  scrollBehavior (to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
  }
});

// A subdomain-form address request (e.g. myapp.localhost) resolves through
// the same /:code route as its path form (e.g. localhost/myapp) — only the
// home route's path is rewritten, so every other route is unaffected.
router.beforeEach((to, from, next) => {
  const code = getSubdomainCode();
  if (to.path === '/' && code) {
    next({ path: '/' + code, replace: true });
  } else {
    next();
  }
});

export default router;
